<template lang="pug">
.smartlynq-configuration
  h1.title {{ $t('settings_tab.channels_tab.smartlynq_configuration.title') }}
  .form-container
    .sub-header--solid {{ $t('settings_tab.channels_tab.smartlynq_configuration.cors_title') }}
    .form__inner-content
      cors-configuration(:cors-config="smartlynqCorsConfig"
                         @update="onUpdateCors")
    .sub-header--solid {{ $t('settings_tab.channels_tab.smartlynq_configuration.smart_assist_title') }}
    .form__inner-content
      .label-switch
        span {{ $t('settings_tab.channels_tab.smartlynq_configuration.transfer_to_human_label') }}
        aiq-switch(active-text="",
                   inactive-text="",
                   style="--aiq-switch-on-color: #30C28B; --aiq-switch-off-color: #C0CCDA"
                   v-model="transferToHuman"
                   @change="onUpdateSmartAssist")
</template>

<script>
import CorsConfiguration from '../WebchatConfigurationTab/CorsConfiguration.vue';

export default {
  name: 'smartlynq-configuration-tab',
  components: {
    CorsConfiguration,
  },
  data() {
    return {
      smartlynqCorsConfig: null,
      transferToHuman: false,
    };
  },
  async mounted() {
    try {
      const [
        smartlynqCorsConfig,
        smartAssistConfig,
      ] = await Promise.all(
        [
          'smartlynq_cors_configuration',
          'smartassist_configs',
        ].map(name => this.$store.dispatch('settings/getSetting', { name })),
      );

      this.smartlynqCorsConfig = smartlynqCorsConfig;
      this.transferToHuman = smartAssistConfig?.transfer_to_human?.enabled ?? false;
    } catch (err) {
      this.$aiq.notify.error(err.message);
    }
  },
  methods: {
    async onUpdateCors(newConfig) {
      try {
        this.smartlynqCorsConfig = await this.$store.dispatch('settings/updateSetting', {
          name: 'smartlynq_cors_configuration',
          payload: newConfig,
        });
        this.$aiq.notify.success('Updated');
      } catch (err) {
        this.$aiq.notify.error(err.message);
      }
    },
    async onUpdateSmartAssist(value) {
      try {
        await this.$store.dispatch('settings/updateSetting', {
          name: 'smartassist_configs',
          payload: { transfer_to_human: { enabled: value } },
        });
        this.$aiq.notify.success('Updated');
      } catch (err) {
        this.$aiq.notify.error(err.message);
        this.transferToHuman = !value;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.smartlynq-configuration {
  .title {
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    margin-bottom: 18px;
  }

  .label-switch {
    display: flex;
    align-items: center;
    gap: 12px;
  }
}
</style>
